import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `https://b2.belca.by/php/belca.php`,
    withCredentials: false,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js